import { Dialog, DialogContent, IconButton, Paper } from '@material-ui/core';
import React from 'react';
import Draggable from 'react-draggable';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
function PaperComponent(props: any) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DocumentLayout(props: any) {
  const {
    children,
    isRTL,
    open,
    onClose,
    width,
    height,
    maxWidth = 'lg',
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-describedby="scroll-dialog-description"
      aria-labelledby="draggable-dialog-title"
      maxWidth={maxWidth}
    >
      <IconButton
        style={{ position: 'absolute', right: isRTL ? undefined : 0 }}
        onClick={onClose}
      >
        <CloseOutlinedIcon
          style={{ fontSize: 26, color: '#777' }}
        ></CloseOutlinedIcon>
      </IconButton>
      <DialogContent
        style={{
          width: width ? width : undefined,
          height: height ? height : undefined,
          direction: isRTL ? 'rtl' : 'ltr',
          backgroundColor: '#eee',
        }}
        dividers={true}
      >
        {React.cloneElement(children, { ...props })}
      </DialogContent>
    </Dialog>
  );
}
